import React from 'react';
import BeneficiarySection from '../BeneficiarySection';
import BeneficiarySingleValue from '../BeneficiaryValues/BeneficiarySingleValue';
import { MainCategoryProps } from '../MainCategory';
import { getBeneficiaryIcon } from '../BeneficiaryMainCard';
import {
  Beneficiaries,
  BeneficiaryTitleInfoProps,
} from '../utils/beneficiaryInterfaces';
import { beneficiaryTitle } from '../utils/helperComponents';

const minWidth = 256;

interface BeneficiaryEthnicProps extends BeneficiaryTitleInfoProps {
  beneficiary: Beneficiaries['ethnic'];
  setBeneficiaries: MainCategoryProps['setBeneficiaries'];
}

const BeneficiaryEthnic: React.FC<BeneficiaryEthnicProps> = ({
  beneficiary,
  beneficiaryLabel,
  programName,
  setBeneficiaries,
}) => {
  if (beneficiary === undefined) return null;
  return (
    <BeneficiarySection
      icon={getBeneficiaryIcon('ethnic')}
      setBeneficiaries={setBeneficiaries}
      category="ethnic"
      heading="Ethnic and racial groups"
      title={beneficiaryTitle(
        'the Ethnic and racial groups',
        programName,
        beneficiaryLabel,
      )}
      note={undefined}
    >
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People of African descent"
        buttonLabel="People of African descent"
        inputLabel="African descent"
        categoryName="ethnic"
        category={beneficiary.categories}
        fieldName="People of African descent"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People of Latin American descent"
        buttonLabel="People of Latin American descent"
        inputLabel="Latin American descent"
        categoryName="ethnic"
        category={beneficiary.categories}
        fieldName="People of Latin American descent"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People of European descent"
        buttonLabel="People of European descent"
        inputLabel="European descent"
        categoryName="ethnic"
        category={beneficiary.categories}
        fieldName="People of European descent"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Multiracial people"
        buttonLabel="Multiracial people"
        inputLabel="Multiracial people"
        categoryName="ethnic"
        category={beneficiary.categories}
        fieldName="Multiracial people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People of Asian descent"
        buttonLabel="People of Asian descent"
        inputLabel="Asian descent"
        categoryName="ethnic"
        category={beneficiary.categories}
        fieldName="People of Asian descent"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Indigenous peoples"
        buttonLabel="Indigenous peoples"
        inputLabel="Indigenous peoples"
        categoryName="ethnic"
        category={beneficiary.categories}
        fieldName="Indigenous peoples"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="People of Middle Eastern descent"
        buttonLabel="People of Middle Eastern descent"
        inputLabel="Middle Eastern descent"
        categoryName="ethnic"
        category={beneficiary.categories}
        fieldName="People of Middle Eastern descent"
        setBeneficiaries={setBeneficiaries}
      />
    </BeneficiarySection>
  );
};

export default React.memo(BeneficiaryEthnic);
